module.exports = __webpack_public_path__ + "static/media/addera.af167d7f.mp3";